import { useCallback, useEffect, useState } from 'react'
import moment from "moment";
import "moment/locale/id";
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { FiChevronLeft } from 'react-icons/fi';
import { BiSolidUserRectangle } from "react-icons/bi";
import ItemList from '@components/loadingSchedule/ItemList';
import { InventoryItemLoading, NotificationType } from 'react-app-env';
import axios, { AxiosResponse } from 'axios';
import { API_URL } from '@redux/api';
import Loading from '@components/common/Loading';
import Modal from '@components/common/Modal';
import Notification from '@components/common/Notification';
import { FaListCheck } from "react-icons/fa6";
import LoadingOutConfirmation from '@components/loadingSchedule/LoadingOutConfirmation';

const LoadingOutDetails = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const [notificationFetch, setNotificationFetch] = useState<NotificationType | null>(null);
  const [isLoadingFetch, setIsLoadingFetch] = useState<boolean>(false);
  
  const [isOpenAddInventoriesModal, setIsOpenAddInventoriesModal] = useState<boolean>(false);

  const [sortedInventories, setSortedInventories] = useState<InventoryItemLoading[] | []>([]);

  const fetchLoadingInventories = useCallback(async() => {
    setIsLoadingFetch(true);
    setNotificationFetch(null);

    const response: AxiosResponse = await axios.get(`${API_URL}/loading/${id}/inventories`);
    const { status, data } = response;
    
    if(status === 200) {
      const { inventories } = data.data;
      const sortedData = inventories.sort((a: InventoryItemLoading, b: InventoryItemLoading) => {
        return a.item.name.localeCompare(b.item.name);
      });

      setSortedInventories(sortedData);
      setIsLoadingFetch(false);
    } else {
      setNotificationFetch({
        isError: true,
        title: "Error",
        text: data.message,
      });
      setIsLoadingFetch(false);
    };
  }, [id]);

  useEffect(() => {
    if (state === null) navigate("/jadwal-loading/out");
    return () => { };
  }, [state, navigate]);

  useEffect(() => {
    if(id) fetchLoadingInventories();
    return () => {}
  }, [id, fetchLoadingInventories]);

  useEffect(() => {
    document.body.style.overflow = isOpenAddInventoriesModal ? "hidden" : "unset";
  }, [isOpenAddInventoriesModal]);
  

  if (state === null) return null;

  const {
    adminConfirm,
    isConfirmed,
    confirmationDate,
    eventDate,
    eventLocation,
    pic
  } = state;

  return (
    <div>
      <div className="bg-white rounded-xl p-4">
        <div className='flex items-center'>
          <button onClick={() => navigate("/jadwal-loading/out")} className='pr-4'>
            <FiChevronLeft size={25} />
          </button>
          <h1 className="text-center text-xl w-full md:text-2xl lg:text-4xl font-semibold">Daftar Barang</h1>
        </div>
      </div>

      <div className="bg-white rounded-xl p-4 mt-5">
        <div className='flex items-center justify-center gap-3'>
          <div className="gap-2">
            <strong className="text-lg">{moment(eventDate, "DD/MM/YYYY").format("DD MMM YYYY")}</strong>
            <span className='mx-2'>-</span>
            <strong className="text-lg">{eventLocation}</strong>
          </div>
        </div>
        <hr className="border-gray-300 my-4" />
        <div className="flex items-center justify-center gap-2">
          <BiSolidUserRectangle size={24} />
          <strong>{pic.name}</strong>
          <span>-</span>
          <strong>{pic.phone}</strong>
        </div>
      </div>

      <div className='mt-5'>
        <Notification notification={notificationFetch} />
      </div>

      <div className='mt-5 rounded-xl py-2 px-0'>
        { isLoadingFetch ? 
          <Loading 
            loading={isLoadingFetch}
            size={20}
            type='beat-loader'
            parentClass='mt-8 mb-10'
          />
          : <ItemList inventories={sortedInventories} />
        }
      </div>

      <div className='mt-2 grid grid-cols-1 mb-10'>
        {isConfirmed && confirmationDate ?
          <div className="bg-green-600 text-white rounded-xl mt-5 py-4">
            <p className="text-center uppercase font-semibold">Sudah Dikonfirmasi</p>
            <p className="text-center">Oleh : <strong>{adminConfirm.name}</strong></p>
            <p className="text-center">Tanggal : <strong>{moment(confirmationDate, "MM/DD/YYYY, HH:mm:ss").format("DD MMM YYYY")}</strong></p>
          </div>
          : <button
            className='w-full bg-orange-500 text-white py-2 md:py-4 rounded-xl flex items-center justify-center gap-2'
            onClick={() => setIsOpenAddInventoriesModal(true)}
          >
            <FaListCheck />
            Konfirmasi Loading Out
          </button>
        }
      </div>

      <Modal
        showCloseButton
        title="Konfirmasi Loading Out"
        isOpen={isOpenAddInventoriesModal}
        onClose={() => setIsOpenAddInventoriesModal(false)}
      >
        <div className="border-t">
          <LoadingOutConfirmation
            loadingId={id}
            inventories={sortedInventories}
            onCloseModal={() => {
              setIsOpenAddInventoriesModal(false);
              navigate("/jadwal-loading");
            }} 
          />
        </div>
      </Modal>
    </div>
  )
}

export default LoadingOutDetails